var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchools(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6dcef8;}.b{fill:#2450ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-540 -1210)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-7613-1556v-25h36v25c0,2.761-8.058,5-18,5S-7613-1553.239-7613-1556Z",
    transform: "translate(8165 2801)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2,
    height: 20,
    transform: "translate(542 1220)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.586.212a2.683,2.683,0,0,1,1.478,0L62.727,8.19a1.95,1.95,0,0,1,0,3.836L35.064,20a2.684,2.684,0,0,1-1.478,0L5.922,12.026a1.95,1.95,0,0,1,0-3.836Z",
    transform: "translate(535.675 1209.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.177.139a.366.366,0,0,1,.3,0L16,2.533a.678.678,0,0,1,0,1.151L10.472,6.077a.366.366,0,0,1-.3,0L4.644,3.684a.678.678,0,0,1,0-1.151Z",
    transform: "translate(546.108 1233.676) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H50a5,5,0,0,1,5,5V5a5,5,0,0,1-5,5H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(545 1260)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(540 1260)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchools);
export default __webpack_public_path__ + "static/media/schools.67b0b0e3ceabfbd795ac28cfd76701d3.svg";
export { ForwardRef as ReactComponent };